import React from 'react';

const ShiftLegend = () => {
  const legendItems = [
    { 
      label: 'Zugewiesen', 
      color: 'bg-blue-500', 
      textColor: 'text-blue-700',
      description: 'Ihre bestätigten Schichten'
    },
    { 
      label: 'Verfügbar', 
      color: 'bg-green-500', 
      textColor: 'text-green-700',
      description: 'Buchbare Schichten'
    },
    { 
      label: 'Angefragt', 
      color: 'bg-yellow-500', 
      textColor: 'text-yellow-700',
      description: 'Wartende Anfragen'
    },
    { 
      label: 'Nicht verfügbar', 
      color: 'bg-gray-400', 
      textColor: 'text-gray-600',
      description: 'Nicht buchbar'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <h3 className="text-sm font-medium text-foreground mb-3">Schicht-Status</h3>
      <div className="space-y-3">
        {legendItems?.map((item, index) => (
          <div key={index} className="flex items-start space-x-3">
            <div className={`w-3 h-3 rounded-full ${item?.color} mt-0.5 flex-shrink-0`} />
            <div className="flex-1 min-w-0">
              <p className={`text-sm font-medium ${item?.textColor}`}>
                {item?.label}
              </p>
              <p className="text-xs text-muted-foreground">
                {item?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ShiftLegend;